export default __webpack_public_path__ + "static/media/ctrltogo-big.de86413a.svg";